export function isMatrix(transformer) {
    return transformer instanceof Float32Array || transformer instanceof Array;
}
//# sourceMappingURL=isMatrix.js.map